// Configuración del sistema de tracking
export const TRACKING_CONFIG = {
  // Configuración general
  ENABLED: true,
  DEBUG: false,
  
  // Límites de rendimiento - Optimizado para fluidez
  MAX_EVENTS_PER_MINUTE: 30, // Aumentado para page views
  BATCH_SIZE: 5, // Lotes pequeños para envío rápido
  FLUSH_INTERVAL: 10000, // 10 segundos entre envíos
  
  // Throttling - Mínimo para fluidez
  CLICK_THROTTLE: 2000, // 2 segundos entre clics
  PAGE_VIEW_THROTTLE: 1000, // Solo 1 segundo entre page views
  
  // Eventos específicos - Optimizado para fluidez
  EVENTS: {
    PAGE_VIEWS_ENABLED: true, // ← ACTIVAR para tracking automático
    CLICKS_ENABLED: false, // Desactivado para fluidez
    DOWNLOADS_ENABLED: true, // Mantener activo
    USER_BEHAVIOR_ENABLED: false, // Desactivado para fluidez
    API_CALLS_ENABLED: false, // Desactivado para fluidez
  },
  
  // Configuración de elementos a trackear
  TRACKABLE_ELEMENTS: {
    BUTTONS: true,
    LINKS: true,
    FORMS: true,
    DOWNLOADS: true,
    DATA_TRACK_ATTRIBUTES: true,
  },
  
  // Configuración de filtros
  FILTERS: {
    IGNORE_SYSTEM_CLICKS: true, // Ignorar clics del sistema
    IGNORE_RAPID_CLICKS: true, // Ignorar clics muy rápidos
    IGNORE_SCROLL_EVENTS: true, // Ignorar eventos de scroll
  }
};

// Función para verificar si el tracking está habilitado
export const isTrackingEnabled = (): boolean => {
  return TRACKING_CONFIG.ENABLED;
};

// Función para verificar si un tipo de evento está habilitado
export const isEventTypeEnabled = (eventType: keyof typeof TRACKING_CONFIG.EVENTS): boolean => {
  return TRACKING_CONFIG.EVENTS[eventType];
};

// Función para obtener la configuración de throttling
export const getThrottleConfig = () => ({
  click: TRACKING_CONFIG.CLICK_THROTTLE,
  pageView: TRACKING_CONFIG.PAGE_VIEW_THROTTLE,
});

export default TRACKING_CONFIG;